import React, { useEffect, useRef } from 'react';
import Webamp from 'webamp';
import { initialTracks } from './config';

function Winamp({ onClose, onMinimize, onPlay }) {
  const ref = useRef(null);
  const webamp = useRef(null);
  const wasPlayingRef = useRef(false);
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    webamp.current = new Webamp({
      initialTracks,
    });
    webamp.current.renderWhenReady(target).then(() => {
      target.appendChild(document.querySelector('#webamp'));
      // Enable shuffle by default
      const store = webamp.current.store;
      if (store && !store.getState().media.shuffle) {
        store.dispatch({ type: 'TOGGLE_SHUFFLE' });
      }
      // Notify parent when playback starts
      if (store && onPlay) {
        store.subscribe(() => {
          const playing = store.getState().media.status === 'PLAYING';
          if (playing && !wasPlayingRef.current) onPlay();
          wasPlayingRef.current = playing;
        });
      }
    });
    return () => {
      webamp.current.dispose();
      webamp.current = null;
    };
  }, []);
  useEffect(() => {
    if (webamp.current) {
      webamp.current.onClose(onClose);
      webamp.current.onMinimize(onMinimize);
    }
  });
  return (
    <div
      style={{ position: 'fixed', left: 0, top: 0, right: 0, bottom: 0 }}
      ref={ref}
    />
  );
}

export default Winamp;
